export const BACKEND_URL = process.env.BACKEND_URL;
export const SPACE = process.env.SPACE;
export const TICKET_FRAME_URL = process.env.TICKET_FRAME_URL as string;

export const MOBILE_RESOLUTION = 440;
export const TABLET_RESOLUTION = 1025;

export const EMPTY_META = {
  title: 'Остров мечты',
  description: undefined,
  image: undefined,
  canonical: undefined,
  h1: undefined,
  keywords: undefined,
  robots: undefined,
  text: undefined,
};

export const PASSWORD_REGEX =
  /^^(?=.*[a-zA-Z])(?=.*\d)[a-zA-Z\d!@#$%^&*()-_=+{};:,.<>?]{8,}$/;

export const EMAIL_REGEX = /[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}/;

export const PHONE_REGEX = /\+\d\s?\(\d{3}\)\s?\d{3}-\d{2}-\d{2}/;

export const PARK_RAZVLECHENIY_CODE = 'park';
export const DREAM_BEACH_CLUB_CODE = 'beach-club';
export const PROMENAD_CODE = 'promenade';
export const DREAM_GAME_CENTER_CODE = 'game-center';
export const SOUTH_LANDSCAPE_CODE = 'south-landscape';
export const CONCERT_HALL_CODE = 'concert-hall';
export const SUMMER_CINEMA_CODE = 'summer-cinema';

export const darkHeaderPages = [
  '/restaurants',
  '/shops',
  '/trades',
  '/entertainments',
  `/objects/${DREAM_BEACH_CLUB_CODE}`,
  `/objects/${PROMENAD_CODE}`,
  `/objects/${DREAM_GAME_CENTER_CODE}`,
  `/objects/${SOUTH_LANDSCAPE_CODE}`,
  `/objects/${PARK_RAZVLECHENIY_CODE}`,
  '/new-year-gift-2024',
];

export const PAGES_WITH_PYRUS_CHAT = ['/', '/tickets/buy'];
export const ACCESS_TOKEN_KEY = 'accessToken';
export const REFRESH_TOKEN_KEY = 'refreshToken';
export const CSRF_TOKEN_KEY = 'csrf';

export const BLACK_COLOR = '#18232e';
export const YELLOW_COLOR = '#FFF7CC';
export const BLUE_COLOR = '#000337';

export const PARK_TIME_ZONE = 'Europe/Moscow';

export const CERTIFICATE_FORM = 'CERTIFICATE_FORM';
export const CERTIFICATE_PRICE = 'CERTIFICATE_PRICE';

export const ENTERTAINMENTS_FILTERS_DATA = 'ENTERTAINMENTS_FILTERS_DATA';
export const ENTERTAINMENTS_BUTTON_MORE_COUNT =
  'ENTERTAINMENTS_BUTTON_MORE_COUNT';
export const ENTERTAINMENTS_PAST_SCROLL_POSITION =
  'ENTERTAINMENTS_PAST_SCROLL_POSITION';
export const NO_SEATS_ERROR_CODE = 'event_no_seats';
